import CardLayout from 'components/layouts/CardLayout'
import Onboarding from 'components/pages/Onboarding'
import GatherHeader from 'components/features/pfm/GatherHeader/GatherHeader'
import { ComponentProps, FC, ReactNode } from 'react'
import styles from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset.styl'
import SvgIcon from 'components/atoms/SvgIcon'
import CrossSvg from 'icons/cross.svg'
import ArrowSvg from 'icons/arrow.svg'
import cn from 'classnames'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { onboardingStepsCountSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

type OnboardingPagePresetProps =
& Omit<ComponentProps<typeof GatherHeader>, 'maxStep'>
& {
  card: ReactNode
  progressPercent?: number
  subTitle?: ReactNode
  className?: string
  onClose?: () => void
  onBack?: () => void
}
export const OnboardingPagePreset: FC<OnboardingPagePresetProps> = (props) => {
  const { children, title, step, subTitle, card, progressPercent = 0, className, onClose, onBack } = props

  const stepsCount = useStoreSelector(onboardingStepsCountSelector)

  const isNavButtonsVisible = IS_STATUS_APP

  return (
    <div className={ cn(styles.page, className) }>
      { isNavButtonsVisible && onClose && (
        <div className={ styles.closeButton }>
          <button onClick={ onClose }>
            <SvgIcon src={ CrossSvg } />
          </button>
        </div>
      )}
      { isNavButtonsVisible && onBack && (
        <div className={ styles.backButton }>
          <button onClick={ onBack }>
            <SvgIcon src={ ArrowSvg } />
          </button>
        </div>
      )}

      <Onboarding progressPercent={ progressPercent }>
        <GatherHeader
          title={ title }
          step={ step }
          maxStep={ stepsCount }
          className={ styles.header }
        >
          { subTitle }
        </GatherHeader>
        { card && (
          <CardLayout className={ styles.card }>
            { card }
          </CardLayout>
        )}
        { children }
      </Onboarding>
    </div>
  )
}
